import { useSearchParams } from 'react-router-dom';
import { useAppSelector } from 'store/hooks';
import { selectImagesLimit } from 'store/page/pageSlice';

export const LIMIT = 28;

export const useOffsetLimit = () => {
  const [searchParams] = useSearchParams();
  const imagesLimit = useAppSelector(selectImagesLimit);
  const page = Number(searchParams.get('page') || 1);

  return {
    offset: (page - 1) * imagesLimit,
    limit: imagesLimit,
  };
};
